import { SCALE } from "../utils/constants";
import LevelTest from "./levels/level_ki_finale";
import Level1 from "../components/levels/level_1";
import Level2 from "../components/levels/level_2";
import Level3 from "../components/levels/level_3";
import Level4 from "../components/levels/level_4";
import Level5 from "../components/levels/level_5";
import Level6 from "../components/levels/level_6";
import Level7 from "../components/levels/level_7";
import Level8 from "../components/levels/level_8";
import Level9 from "../components/levels/level_9";
import Level10 from "../components/levels/level_10";
import Level11 from "../components/levels/level_11";
import Level12 from "../components/levels/level_12";
import Level13 from "../components/levels/level_13";
import Level14 from "../components/levels/level_14";
import Level15 from "../components/levels/level_15";
import Level16 from "../components/levels/level_16";
import Level17 from "../components/levels/level_17";
import Level18 from "../components/levels/level_18";
import LevelFinale from "../components/levels/level_ki_finale";
import LevelMaze1 from "../components/levels/Maze_1";
import UI from "./UI";
import { translate } from "../utils/localization";
import Arrow from "./DialogArrow";
import DB from "../utils/dbManager";
import dbManager from "../utils/dbManager";
import LevelMaze2 from "./levels/Maze_2";
import LevelKiFinale from "./levels/level_ki_finale";
import * as Controller from "./Controller/Controller";

export default class UIMenus {
  constructor(scene) {
    this.scene = scene;
    this.ROW_HEIGHT = 0;
    this.MARGIN_LEFT = 0;
    this.MARGIN_TOP = 0;
    this.options = [];
    this.optionsByPage = [];
    this.scrollIndex = 0;
    this.isVisible = true;

    window.scene = this.scene;
  }
  showConfirmNewGameMenu() {
    const menuOptions = [
      {
        label: translate("menu.main.yes"),
        disabled: false,
        selectable: true,
        onSelect: () => {
          this.scene.navigateToScene("IntroScene");
        },
      },
      {
        label: translate("menu.main.no"),
        disabled: false,
        selectable: true,
        onSelect: () => this.scene.navigateToScene("SplashScreenScene"),
      },
    ];
    const header = {
      label: translate("menu.main.confirmNewGame"),
      disabled: false,
      selectable: false,
    };
    this.drawSelectableOptions(header, menuOptions, 0, 1, 2);
  }
  async showInitialMenu() {
    const menuOptions = [
      {
        label: translate("menu.main.option_new"),
        disabled: false,
        selectable: true,
        onSelect: async () => {
          const level_1 = await dbManager.get(Level1.key);
          if (level_1) {
            this.scene.navigateToScene("ConfirmNewGameScene");
          } else {
            this.scene.navigateToScene("IntroScene");
          }
        },
      },
      {
        label: translate("menu.main.option_continue"),
        disabled: false,
        selectable: true,
        // onSelect: () => this.scene.navigateToScene("LevelResumeScene", { level: Level3.key}),
        onSelect: () => {
          console.log(document.querySelector('canvas').width, document.querySelector('canvas').height, document.querySelector('canvas'));
          this.scene.navigateToScene("MenuScene")
        },
      },
      {
        label: translate("menu.main.toBeContinue"),
        disabled: !((await dbManager.get(LevelKiFinale.key))?.comp > 0),
        selectable: !((await dbManager.get(LevelKiFinale.key))?.comp > 0),
        // onSelect: () => this.scene.navigateToScene("LevelResumeScene", { level: Level3.key}),
        onSelect: () => this.scene.navigateToScene("KiStageCompleted"),
      },
      {
        label: "Options",
        disabled: true,
        selectable: false,
        // onSelect: () => this.scene.navigateToScene("LevelResumeScene", { level: Level3.key}),
        onSelect: () => this.scene.navigateToScene("OptionsScene"),
      },
    ];
    this.drawSelectableOptions(null, menuOptions);
  }
  async showMainMenu() {
    // const levelData = DB.get(Level1.key);
    // const maxProgress = DB.get("maxProgress") || 1;
    // shorthand formatter
    const _ = (n = "") =>
      n.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
      });
    const _gems = async (lKey) => {
      const levelData = await DB.get(lKey);
      return levelData
        ? `${_(levelData.collectedDiamonds)}/${_(levelData.countDiamonds)}`
        : "__/__";
    };
    const _threats = async (lKey) => {
      const levelData = await DB.get(lKey);
      return levelData
        ? `${_(levelData.killedEnemies)}/${_(levelData.countEnemies)}`
        : "__/__";
    };
    const _shrooms = async (lKey) => {
      const levelData = await DB.get(lKey);
      return levelData
        ? `${_(levelData.collectedShrooms)}/${_(levelData.countShrooms)}`
        : "__/__";
    };
    const _comp = async (lKey) => {
      const levelData = await DB.get(lKey);
      const perc = (levelData?.comp * 100).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return levelData
        ? `${perc <= 9 ? "  " : perc <= 99 ? " " : ""}${perc}%`
        : "  0%";
    };

    const menuOptions = [
      {
        label: `Ki     1     ${await _gems(Level1.key)}     ${await _threats(
          Level1.key
        )}     ${await _shrooms(Level1.key)}   ${await _comp(Level1.key)}`,
        // label: "Ki     1     __/__     __/__     __/__   100%",
        disabled: false,
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level1.key }),
      },
      {
        label: `Ki     2     ${await _gems(Level2.key)}     ${await _threats(
          Level2.key
        )}     ${await _shrooms(Level2.key)}   ${await _comp(Level2.key)}`,
        // label: "Absu  2     __/__     __/__     __/__   100%",
        disabled: !((await dbManager.get(Level1.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level2.key }),
      },
      {
        label: `Ki     3     ${await _gems(Level3.key)}     ${await _threats(
          Level3.key
        )}     ${await _shrooms(Level3.key)}   ${await _comp(Level3.key)}`,
        disabled: !((await dbManager.get(Level2.key))?.comp > 0),
        // disabled: !((await dbManager.get(Level3.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level3.key }),
      },
      {
        label: `Ki     4     ${await _gems(Level4.key)}     ${await _threats(
          Level4.key
        )}     ${await _shrooms(Level4.key)}   ${await _comp(Level4.key)}`,
        disabled: !((await dbManager.get(Level3.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level4.key }),
      },
      {
        label: `Ki     5     ${await _gems(Level5.key)}     ${await _threats(
          Level5.key
        )}     ${await _shrooms(Level5.key)}   ${await _comp(Level5.key)}`,
        disabled: !((await dbManager.get(Level4.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level5.key }),
      },
      {
        label: `Ki     6     ${await _gems(Level6.key)}     ${await _threats(
          Level6.key
        )}     ${await _shrooms(Level6.key)}   ${await _comp(Level6.key)}`,
        disabled: !((await dbManager.get(Level5.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level6.key }),
      },
      {
        label: `Ki     7     ${await _gems(Level7.key)}     ${await _threats(
          Level7.key
        )}     ${await _shrooms(Level7.key)}   ${await _comp(Level7.key)}`,
        disabled: !((await dbManager.get(Level6.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level7.key }),
      },
      {
        label: `Ki     8     ${await _gems(Level8.key)}     ${await _threats(
          Level8.key
        )}     ${await _shrooms(Level8.key)}   ${await _comp(Level8.key)}`,
        disabled: !((await dbManager.get(Level7.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level8.key }),
      },
      {
        label: `Ki     9     ${await _gems(Level9.key)}     ${await _threats(
          Level9.key
        )}     ${await _shrooms(Level9.key)}   ${await _comp(Level9.key)}`,
        disabled: !((await dbManager.get(Level8.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level9.key }),
      },
      {
        label: `Ki    10     ${await _gems(Level10.key)}     ${await _threats(
          Level10.key
        )}     ${await _shrooms(Level10.key)}   ${await _comp(Level10.key)}`,
        disabled: !((await dbManager.get(Level9.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level10.key }),
      },
      {
        label: `Ki    11     ${await _gems(Level11.key)}     ${await _threats(
          Level11.key
        )}     ${await _shrooms(Level11.key)}   ${await _comp(Level11.key)}`,
        disabled: !((await dbManager.get(Level10.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level11.key }),
      },
      {
        label: `Ki    12     ${await _gems(Level12.key)}     ${await _threats(
          Level12.key
        )}     ${await _shrooms(Level12.key)}   ${await _comp(Level12.key)}`,
        disabled: !((await dbManager.get(Level11.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level12.key }),
      },
      {
        label: `${translate("menu.main.ruins").padEnd(6, " ")} 1`,
        disabled: !((await dbManager.get(Level12.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", {
            levelName: LevelMaze1.key,
          }),
      },
      {
        label: `Ki    13     ${await _gems(Level13.key)}     ${await _threats(
          Level13.key
        )}     ${await _shrooms(Level13.key)}   ${await _comp(Level13.key)}`,
        disabled: !((await dbManager.get(LevelMaze1.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level13.key }),
      },
      {
        label: `Ki    14     ${await _gems(Level14.key)}     ${await _threats(
          Level14.key
        )}     ${await _shrooms(Level14.key)}   ${await _comp(Level14.key)}`,
        disabled: !((await dbManager.get(Level13.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level14.key }),
      },
      {
        label: `Ki    15     ${await _gems(Level1.key)}     ${await _threats(
          Level15.key
        )}     ${await _shrooms(Level15.key)}   ${await _comp(Level15.key)}`,
        disabled: !((await dbManager.get(Level14.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level15.key }),
      },
      {
        label: `Ki    16     ${await _gems(Level16.key)}     ${await _threats(
          Level16.key
        )}     ${await _shrooms(Level16.key)}   ${await _comp(Level16.key)}`,
        disabled: !((await dbManager.get(Level15.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level16.key }),
      },
      {
        label: `Ki    17     ${await _gems(Level17.key)}     ${await _threats(
          Level17.key
        )}     ${await _shrooms(Level17.key)}   ${await _comp(Level17.key)}`,
        disabled: !((await dbManager.get(Level16.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level17.key }),
      },
      {
        label: `Ki    18     ${await _gems(Level18.key)}     ${await _threats(
          Level18.key
        )}     ${await _shrooms(Level18.key)}   ${await _comp(Level18.key)}`,
        disabled: !((await dbManager.get(Level17.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", { levelName: Level18.key }),
      },
      {
        label: `${translate("menu.main.ruins").padEnd(6, " ")} 2`,
        disabled: !((await dbManager.get(Level18.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", {
            levelName: LevelMaze2.key,
          }),
      },
      {
        label: `Ki    19     ${await _gems(
          LevelFinale.key
        )}     ${await _threats(LevelFinale.key)}     ${await _shrooms(
          LevelFinale.key
        )}   ${await _comp(LevelFinale.key)}`,
        disabled: !((await dbManager.get(LevelMaze2.key))?.comp > 0),
        selectable: true,
        onSelect: () =>
          this.scene.navigateToScene("GameScene", {
            levelName: LevelFinale.key,
          }),
      },
    ];

    const header = {
      label: translate("menu.main.heading_scrore"),
      disabled: false,
      selectable: false,
    };

    // last option selected by default
    this.drawSelectableOptions(
      header,
      menuOptions,
      0, //menuOptions.length - 1,
      null,
      null,
      13
    );
  }
  showInGameMenu() {
    const menuOptions = [
      {
        label: translate("menu.main.option_restart_level"),
        disabled: false,
        selectable: true,
        onSelect: () => this.scene.levels.restart(),
      },
      {
        label: translate("menu.main.option_back_to_menu"),
        disabled: false,
        selectable: true,
        onSelect: () => this.scene.navigateToScene("MenuScene"),
      },
    ];

    this.drawSelectableOptions(null, menuOptions, 0, 4, 1);
  }

  drawSelectableOptions(
    header,
    options,
    initOption,
    offsetX,
    offsetY,
    maxRows = 5
  ) {
    this.options = options;

    const FIRST_SELECTABLE_OPTION = options.findIndex(
      (o) => o.selectable && !o.disabled
    );

    let currentOption = FIRST_SELECTABLE_OPTION;
    if (initOption >= maxRows - 1) {
      // must scroll options
      if (initOption < this.options.length) {
        this.scrollIndex = initOption - maxRows + 1;
        const haveMorePages = this.scrollIndex + maxRows < this.options.length;
        if (haveMorePages) {
          this.scrollIndex = initOption - maxRows + 2;
          // arrow points one before the last
          currentOption = maxRows - 2;
        } else {
          // arrow points the last option
          currentOption = maxRows - 1;
        }
        // and list scrolls up to that option
      } else {
        // latest option, arrow should point to that
        currentOption = maxRows;
        this.scrollIndex = initOption - maxRows;
      }
    } else if (!isNaN(initOption)) {
      currentOption = initOption;
    }

    const currentPage = Math.floor(currentOption / maxRows) + 1;
    let currentIndex = currentOption - Math.floor((currentPage - 1) * maxRows);

    const INIT_POS = currentOption;
    this.ROW_HEIGHT = UI.pixelToScreen(15);
    this.MARGIN_LEFT = UI.tileToScreen(offsetX || 1);
    const ARROW_WIDTH = UI.pixelToScreen(20);
    const OFFSET_X = this.MARGIN_LEFT - ARROW_WIDTH;
    this.MARGIN_TOP = UI.tileToScreen(offsetY || 2);

    const arrow = new Arrow(this.scene).getArrowRight();
    arrow.tilemapLayer.setPosition(
      OFFSET_X,
      this.MARGIN_TOP + this.ROW_HEIGHT * INIT_POS - this.ROW_HEIGHT / 2
    );

    const arrowUp = new Arrow(this.scene).getArrowUp();
    arrowUp.tilemapLayer.setPosition(
      UI.tileToScreen(19),
      this.MARGIN_TOP - this.ROW_HEIGHT
    );
    arrowUp.setAlpha(this.scrollIndex === 0 ? 0.5 : 1);
    arrowUp.setVisible(maxRows < this.options.length);

    const arrowDown = new Arrow(this.scene).getArrowDown();
    arrowDown.tilemapLayer.setPosition(
      UI.tileToScreen(19),
      this.MARGIN_TOP + this.ROW_HEIGHT * maxRows - this.ROW_HEIGHT
    );
    arrowDown.setAlpha(
      this.scrollIndex + maxRows < this.options.length ? 1 : 0.5
    );
    arrowDown.setVisible(maxRows < this.options.length);

    if (header) {
      const label = [
        ...header.label.split(""),
        ...Array(Math.max(0, 20 - header.label.length)).fill(""),
      ].join("");
      const lines = Math.round(label.length / 20);
      const txt = this.scene.add
        .text(
          this.MARGIN_LEFT,
          this.ROW_HEIGHT * -lines + this.MARGIN_TOP,
          label,
          {
            fontFamily: "Emulogic",
            fontSize: "8px",
            fill: "#aee0c8",
            fontWeight: "regular",
          }
        )
        .setVisible(!header.disabled);
      txt.displayHeight = 10 * SCALE;
      txt.alpha = 1;
      txt.depth = 16;
      txt.name = "header_text";
      txt.setScale(SCALE);
      txt.setScrollFactor(0);
      txt.setShadow(-1, 1);
    }

    this.drawOptionsPage(this.scrollIndex, maxRows, currentIndex);

    this.scene.input.keyboard.on("keydown", (event) => {
      // break control for in game pause menu
      if (!this.isVisible) return false;

      const reducedOptions = this.optionsByPage.filter((o) => !o.disabled);
      let newIndex = false;
      if (Controller.isUp(event.key)) {
        const isNextToFirstOption = currentIndex === 1;
        const scrollOptions = isNextToFirstOption && this.scrollIndex > 0;
        if (scrollOptions) {
          this.scrollIndex--;
          this.drawOptionsPage(this.scrollIndex, maxRows, currentIndex);
        } else {
          // move arrow
          if (currentIndex > 0) {
            newIndex = currentIndex - 1;
          }
        }
      }

      const lastAvailableOption = currentIndex === reducedOptions.length - 1;
      if (Controller.isDown(event.key) && !lastAvailableOption) {
        const isNextToLastOption = currentIndex === maxRows - 2;
        const scrollOptions =
          isNextToLastOption &&
          this.scrollIndex + maxRows < this.options.length;
        if (scrollOptions) {
          this.scrollIndex++;
          this.drawOptionsPage(this.scrollIndex, maxRows, currentIndex);
        } else {
          // move arrow
          if (currentIndex < reducedOptions.length - 1) {
            newIndex = currentIndex + 1;
          }
        }
      }

      if (
        (Controller.isDown(event.key) || Controller.isUp(event.key)) &&
        newIndex !== false
      ) {
        arrow.tilemapLayer.setPosition(
          OFFSET_X,
          this.MARGIN_TOP + this.ROW_HEIGHT * newIndex - this.ROW_HEIGHT / 2
        );
        const prevSelectedOpt = this.scene.children.getByName(
          `menu_text_${currentIndex}`
        );
        prevSelectedOpt.alpha =
          prevSelectedOpt.text.slice(-4) === "100%" ? 1 : 0.5;
        prevSelectedOpt.setColor("#aee0c8");
        const nextSelectedOpt = this.scene.children.getByName(
          `menu_text_${newIndex}`
        );
        nextSelectedOpt.alpha = 1;
        nextSelectedOpt.setColor("#fff");
        currentIndex = newIndex;
      }

      // up down arrows maintenance
      arrowUp.setAlpha(this.scrollIndex === 0 ? 0.5 : 1);
      arrowDown.setAlpha(currentIndex === reducedOptions.length - 1 ? 0.5 : 1);

      if (Controller.isConfirm(event.key)) {
        if (!reducedOptions[currentIndex].disabled) {
          reducedOptions[currentIndex].onSelect();
        }
      }
    });
  }

  drawOptionsPage(from, length, current) {
    // clean up
    this.scene.children.list
      .filter((el) => el.name.includes("menu_text"))
      .forEach((el) => el.destroy());
    this.optionsByPage = this.options.slice(from, from + length);

    this.optionsByPage.forEach((o, idx) => {
      const textToPrint = [
        ...o.label.split(""),
        ...Array(Math.max(0, 20 - o.label.length)).fill(""),
      ].join("");
      const txt = this.scene.add
        .text(
          this.MARGIN_LEFT,
          this.ROW_HEIGHT * idx + this.MARGIN_TOP,
          textToPrint,
          {
            fontFamily: "Emulogic",
            fontSize: "8px",
            fill: "#aee0c8",
            fontWeight: "regular",
          }
        )
        .setVisible(!o.disabled);
      txt.alpha = textToPrint.slice(-4) === "100%" || idx === current ? 1 : 0.5;
      txt.setColor(idx === current ? "#fff" : "#aee0c8");
      txt.displayHeight = 10 * SCALE;
      txt.depth = 16;
      txt.name = `menu_text_${idx}`;
      txt.setScale(SCALE);
      txt.setScrollFactor(0);
      txt.setShadow(-1, 1);
    });
  }
}
